module.exports = __webpack_public_path__ + "static/media/dep-review.9bff3854.png";